<template>
  <div class="offer-promos-error grid-y align-center align-middle margin-top-l margin-bottom-l">
    <span class="offers"></span>
    <p class="margin-top-xs margin-bottom-s large">
      {{ OFFERPROMOS.offerErrorPrimaryText }}
      <a v-if="brand === 'bcom'" :href="OFFERPROMOS.offerErrorLink">{{ `${OFFERPROMOS.offerErrorSecondaryText}.` }}</a>
    </p>
    <a v-if="brand === 'mcom'" :href="OFFERPROMOS.offerErrorLink" class="primary button">{{ OFFERPROMOS.viewOffers }}</a>
  </div>
</template>
<script setup>
import { OFFERPROMOS, brand } from 'config';
</script>
<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_offers.scss';
</style>
